import React, { Component } from 'react'
import { withRadium, DetectCompact } from 'higher-order-components/'
import { rafThrottle } from 'utils'
import { childParser } from 'containers/utilities'
import { findDOMNode } from 'react-dom'
import { Body } from 'containers'
import { WINDOW, HAS_TOUCH } from 'constants/environment'
import bowser from 'bowser'

/** Fixed Bar Component. */
class FixedBar extends Component {
  constructor() {
    super()
    this.state = {
      isVirtualKeyboard: false,
      currentWidth: WINDOW.innerWidth,
      currentHeight: WINDOW.innerHeight
    }
  }

  componentDidMount() {
    Body.padBottom(findDOMNode(this).clientHeight + 'px')
    this.handleResize = rafThrottle(this.resize)
    // This is for hiding the fixed bar when there is virtual keyboard on Android chrome SM-1146
    // There is no API for detecting a virtual keyboard, so the logic is based on viewport height
    // change when the keyboard appears.
    WINDOW.addEventListener('resize', this.detectVirtualKeyboard)
  }
  componentWillUnmount() {
    WINDOW.removeEventListener('resize', this.detectVirtualKeyboard)
  }

  componentDidUpdate() {
    if (Body.body.style.paddingBottom !== findDOMNode(this).clientHeight + 'px') {
      Body.padBottom(findDOMNode(this).clientHeight + 'px')
    }
  }

  detectVirtualKeyboard = () => {
    if (this.props.compact && HAS_TOUCH && bowser.android) {
      if (WINDOW.innerWidth === this.state.currentWidth) {
        if (this.state.currentHeight > WINDOW.innerHeight + 200) {
          this.setState({ isVirtualKeyboard: true })
        } else if (this.state.isVirtualKeyboard) {
          this.setState({ isVirtualKeyboard: false })
        }
      } else {
        this.setState({
          currentWidth: WINDOW.innerWidth,
          currentHeight: WINDOW.innerHeight
        })
      }
    }
  }

  render() {
    const { innerRef } = this.props
    return (
      <div
        ref={innerRef}
        style={[styles.base, this.state.isVirtualKeyboard && { display: 'none' }]}
        data-test="fixed-bar">
        {childParser(this.props)}
      </div>
    )
  }
}

export default withRadium(DetectCompact())(FixedBar)

const styles = {
  base: {
    position: 'fixed',
    width: '100%',
    bottom: 0,
    borderTop: '1px solid #e5e5e5',
    backgroundColor: '#fff',
    padding: '.5em 0',
    zIndex: '20',
    textAlign: 'left',
    lineHeight: '1.2em',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
}



// WEBPACK FOOTER //
// ./src/containers/fixed-bar/index.jsx